import React from 'react'
import { getBEMCls } from '@/utils/classname'

import './stock-join-card.scss'
import { StockJoinList } from './stock-join-table'
import { formatDay } from '@/utils'
import StockJoinForm from '../stock-join-form/stock-join-form'
import { showLayer } from '@/utils/layer'

interface StockJoinCardProps {
    stockInOrder: StockJoinList
    refresh: () => void
}

const StockJoinCard: React.FC<StockJoinCardProps> = ({ stockInOrder, refresh }) => {
    const cls = (...arg: string[]) => getBEMCls('stock-join', ...arg)

    return (
        <div
            className={cls('container')}
            onClick={() => {
                showLayer(<StockJoinForm refresh={refresh} id={stockInOrder.id} />)
            }}
        >
            <div className={cls('container', 'top')}>
                <div className="tag" />
                <div className="txt">
                    {stockInOrder.source === 'transfer' ? '调拨入库' : `预计${formatDay(stockInOrder?.eta)}到货`}
                </div>
            </div>
            <div className={cls('container', 'goods')}>
                {stockInOrder.order_goods_list.map(list => (
                    <div key={list.id} className={cls('container', 'title')}>
                        <div className={cls('good-name')}>{list.goods.name}</div>
                        <div>
                            {list.stocking_in_amount}
                            {list.stock_in_unit.name}
                        </div>
                    </div>
                ))}
            </div>
            <div className={cls('container', 'des')}>共{stockInOrder.order_goods_list.length}件商品</div>
        </div>
    )
}

export default StockJoinCard
